'use strict';

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyDecoratorToComponent = applyDecoratorToComponent;
exports.applyOptionsToDecorator = applyOptionsToDecorator;
exports["default"] = makeDecorator;

var _constants = require('./constants');

var _enforceDecorator = require('./enforceDecorator');

var _enforceDecorator2 = _interopRequireDefault(_enforceDecorator);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _makeDecoratedComponent = require('./makeDecoratedComponent');

var _makeDecoratedComponent2 = _interopRequireDefault(_makeDecoratedComponent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function applyDecoratorToComponent(decorator) {
  var Component = arguments.length <= 1 || arguments[1] === undefined ? _constants.COMPOSING : arguments[1];

  if (Component === _constants.COMPOSING) {
    return decorator;
  }

  return (0, _makeDecoratedComponent2["default"])([decorator], Component);
}

function applyOptionsToDecorator(constructor) {
  for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    options[_key - 1] = arguments[_key];
  }

  return applyDecoratorToComponent.bind(null, (0, _enforceDecorator2["default"])(constructor.apply(undefined, options)));
}

function makeDecorator(constructDecorator) {
  (0, _invariant2["default"])(typeof constructDecorator === 'function', 'expected `constructDecorator` to be a function but got `%s`', constructDecorator);
  return applyOptionsToDecorator.bind(null, constructDecorator);
}